import { useQuery, UseQueryResult } from 'react-query'
import { UserRoles } from 'shared/consts'
import { LimitsType } from './types'
import { fetchLimits } from './services'
import useLogin from '../useLogin'

export default function useAccountLimits(): UseQueryResult<LimitsType> {
   const { user } = useLogin()

   return useQuery('accountLimits', fetchLimits, { enabled: user.roles.includes(UserRoles.SUBSCRIPTION) })
}
